module.exports = __webpack_public_path__ + "img/portfolio-guide-modal-illustration-en5.2c58093.png";